import { gql } from "@apollo/client";

const USER_INFO = gql`
    query queryUser($id: Float!) {
        user(id: $id) {
            id
            name
            email
            phone
            token
            token_expires_at
            push_token
            uid
            role
            notes
        }
    }
`;

export const USERS = gql`
    query queryUsers {
        users {
            id
            name
            email
            phone
            token
            token_expires_at
            push_token
            uid
            role
            notes
        }
    }
`;

export default USER_INFO;
